import { Breadcrumbs, Link } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { MENU_CONFIG } from './SideMenu';

const PageLink = (props: { pageName: string; onClick: () => void }) => (
  <Link component="button" data-testid={'breadcrumb-link-' + props.pageName} underline="hover" onClick={props.onClick}>
    {props.pageName}
  </Link>
);

const AppBreadcrumbs: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToProjects = () => {
    navigate('/projects');
  };

  const handleProjectsClick = () => {
    navigateToProjects();
  };

  const getBreadcrumbContent = () => {
    const path = location.pathname;
    let result: React.ReactNode[] = [];
    if (path.includes('projects') && path !== '/projects') {
      result = [<PageLink key="projects" pageName={t('menu.ProjectList')} onClick={handleProjectsClick} />];
    }
    if (path.includes('artifacts') && path !== '/artifacts') {
      result = [<PageLink key="artifacts" pageName={t('menu.artifacts')} onClick={() => navigate('/artifacts')} />];
    }
    const menuItem = MENU_CONFIG.find((item) => item.path === path);
    if (menuItem) {
      let displayName = t(menuItem.displayNameKey ?? '');
      if (displayName) {
        result.push(
          <span data-testid={`breadcrumb-link-current-${menuItem.id}`} key="current" style={{ fontSize: '14px', fontWeight: '550', letterSpacing: 0 }}>
            {displayName}
          </span>
        )
      }
    } else if (path.includes('pdf-view')) {
      result.push(<span key="current" style={{ fontSize: '14px', fontWeight: '550', letterSpacing: 0 }}>
        Project Details
      </span>
      );
    }
    return result;
  };

  return (
      <Breadcrumbs aria-label="breadcrumb">
        <PageLink key="artwork" pageName={t('menu.artwork')} onClick={handleProjectsClick} />
        {getBreadcrumbContent()}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;

